import axios from "axios";
import { Storage } from "react-jhipster";

import { SERVER_API_URL } from "./constants";

const TIMEOUT = 20 * 1000;
axios.defaults.timeout = TIMEOUT;
axios.defaults.baseURL = SERVER_API_URL;
const AUTH_TOKEN_KEY = "tamam-authenticationToken";

// Day 21.11 — in-flight GET request deduplication.
// Several pages fire the same GET 2-3 times during a single render cycle
// (component mount + redux refresh + route effect). Without dedupe, the
// browser sends N requests, backend serves N times, network and DB are
// hammered for identical bytes. Sharing the in-flight Promise collapses
// them to one underlying HTTP request — every caller still gets a
// resolution, but only one trip over the wire.
//
// Why: only GETs. POST/PUT/PATCH/DELETE may carry idempotency tokens or
// distinct bodies; deduping them would silently merge real intent.
//
// Key: method + URL + sorted serialized params. Sorting matters so
// `?a=1&b=2` and `?b=2&a=1` collapse to the same entry.
const inflightGets = new Map();

const dedupeKey = (config) => {
  const params = config.params || {};
  const sortedParams = Object.keys(params)
    .sort()
    .map((k) => `${k}=${encodeURIComponent(String(params[k]))}`)
    .join("&");
  return `${(config.method || "get").toUpperCase()}:${config.url || ""}?${sortedParams}`;
};

// axios 1.x: `axios.defaults.adapter` is an array of adapter NAMES
// (['xhr','http','fetch']), not a function. Resolve to a callable via
// axios.getAdapter() before invoking. axios 0.21 had a function here
// directly, hence the previous shape worked without this hop.
const originalAdapter = axios.getAdapter(axios.defaults.adapter);
axios.defaults.adapter = (config) => {
  if ((config.method || "get").toLowerCase() !== "get") {
    return originalAdapter(config);
  }
  const key = dedupeKey(config);
  const existing = inflightGets.get(key);
  if (existing) {
    return existing;
  }
  const promise = originalAdapter(config).finally(() => {
    inflightGets.delete(key);
  });
  inflightGets.set(key, promise);
  return promise;
};

const setupAxiosInterceptors = (onUnauthenticated) => {
  const onRequestSuccess = (config) => {
    const token =
      Storage.local.get(AUTH_TOKEN_KEY) || Storage.session.get(AUTH_TOKEN_KEY);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  };
  const onResponseSuccess = (response) => response;

  const onResponseError = (err) => {
    const status = err.status || (err.response ? err.response.status : 0);
    if (status === 403 || status === 401) {
      onUnauthenticated();
    }
    return Promise.reject(err);
  };
  axios.interceptors.request.use(onRequestSuccess);
  axios.interceptors.response.use(onResponseSuccess, onResponseError);
};

export default setupAxiosInterceptors;
